var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSelect = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.3622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4798758 1029.842h21.040247v19.040249h-21.040247z",
    fill: "#e5e5e5",
    stroke: "#424242",
    strokeDasharray: "1.919503 .959752",
    strokeWidth: 0.959752
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5384617 1030.9006h12.923078v12.923077h-12.923078z",
    fill: "#fce94f",
    stroke: "#c4a000",
    strokeWidth: 1.076923
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.652743 1044.0577-12.756464-6.9791 5.477553 13.6014 2.180887-3.5312 4.312159 4.7134 1.633122-1.5913-4.408599-4.6683 3.561343-1.5449z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSelect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/select.f995ea16.svg";
export { ForwardRef as ReactComponent };